import Icon from 'ms-ui-primitives/Icon';

import type { Props } from '../types';

const Timer = ({
  color,
  size,
  title,
  titleId,
  aphroditeStyles = [],
}: Props) => (
  <Icon
    color="none"
    size={size}
    aphroditeStyles={aphroditeStyles}
    title={title}
    titleId={titleId}
    viewBoxWidth={20}
    viewBoxHeight={20}
  >
    <mask
      id="mask0_1366_2353"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="16"
      height="19"
    >
      <mask
        id="mask1_1366_2353"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask1_1366_2353)">
        <path
          d="M8.33333 2.49967C8.09722 2.49967 7.89931 2.41981 7.73958 2.26009C7.57986 2.10037 7.5 1.90245 7.5 1.66634C7.5 1.43023 7.57986 1.23231 7.73958 1.07259C7.89931 0.912869 8.09722 0.833008 8.33333 0.833008H11.6667C11.9028 0.833008 12.1007 0.912869 12.2604 1.07259C12.4201 1.23231 12.5 1.43023 12.5 1.66634C12.5 1.90245 12.4201 2.10037 12.2604 2.26009C12.1007 2.41981 11.9028 2.49967 11.6667 2.49967H8.33333ZM10 11.6663C10.2361 11.6663 10.434 11.5865 10.5938 11.4268C10.7535 11.267 10.8333 11.0691 10.8333 10.833V7.49967C10.8333 7.26356 10.7535 7.06565 10.5938 6.90592C10.434 6.7462 10.2361 6.66634 10 6.66634C9.76389 6.66634 9.56597 6.7462 9.40625 6.90592C9.24653 7.06565 9.16667 7.26356 9.16667 7.49967V10.833C9.16667 11.0691 9.24653 11.267 9.40625 11.4268C9.56597 11.5865 9.76389 11.6663 10 11.6663ZM10 18.333C8.97222 18.333 8.00347 18.1351 7.09375 17.7393C6.18403 17.3434 5.38889 16.8052 4.70833 16.1247C4.02778 15.4441 3.48958 14.649 3.09375 13.7393C2.69792 12.8295 2.5 11.8608 2.5 10.833C2.5 9.80523 2.69792 8.83648 3.09375 7.92676C3.48958 7.01704 4.02778 6.2219 4.70833 5.54134C5.38889 4.86079 6.18403 4.32259 7.09375 3.92676C8.00347 3.53092 8.97222 3.33301 10 3.33301C10.8611 3.33301 11.6875 3.4719 12.4792 3.74967C13.2708 4.02745 14.0139 4.43023 14.7083 4.95801L15.2917 4.37467C15.4444 4.2219 15.6389 4.14551 15.875 4.14551C16.1111 4.14551 16.3056 4.2219 16.4583 4.37467C16.6111 4.52745 16.6875 4.7219 16.6875 4.95801C16.6875 5.19412 16.6111 5.38856 16.4583 5.54134L15.875 6.12467C16.4028 6.81912 16.8056 7.56217 17.0833 8.35384C17.3611 9.14551 17.5 9.9719 17.5 10.833C17.5 11.8608 17.3021 12.8295 16.9062 13.7393C16.5104 14.649 15.9722 15.4441 15.2917 16.1247C14.6111 16.8052 13.816 17.3434 12.9062 17.7393C11.9965 18.1351 11.0278 18.333 10 18.333ZM10 16.6663C11.6111 16.6663 12.9861 16.0969 14.125 14.958C15.2639 13.8191 15.8333 12.4441 15.8333 10.833C15.8333 9.2219 15.2639 7.8469 14.125 6.70801C12.9861 5.56912 11.6111 4.99967 10 4.99967C8.38889 4.99967 7.01389 5.56912 5.875 6.70801C4.73611 7.8469 4.16667 9.2219 4.16667 10.833C4.16667 12.4441 4.73611 13.8191 5.875 14.958C7.01389 16.0969 8.38889 16.6663 10 16.6663Z"
          fill="#1C1B1F"
        />
      </g>
    </mask>
    <g mask="url(#mask0_1366_2353)">
      <rect width="20" height="20" fill={color} />
    </g>
  </Icon>
);
Timer.displayName = 'Timer';

export default Timer;
